@use "../../styles/breakpoints";
@use "mixins/columns";
@use "mixins/offsets";
@use "mixins/gutter";
@use "mixins/column-widths";

hp6-container {
  position: relative;
  display: block;
  margin: 0 -15px;

  @include breakpoints.xsmall-up {
    @include columns.columns(xs);
    @include offsets.offsets(xs);
    @include column-widths.column-widths(xs);
  }

  @include breakpoints.small-up {
    @include columns.columns(sm);
    @include offsets.offsets(sm);
    @include column-widths.column-widths(sm);
  }

  @include breakpoints.medium-up {
    @include columns.columns(md);
    @include offsets.offsets(md);
    @include column-widths.column-widths(md);
  }

  @include breakpoints.large {
    @include columns.columns(lg);
    @include offsets.offsets(lg);
    @include column-widths.column-widths(lg);
  }

  &.gutter-xs {
    @include gutter.gutter(var(--spacing-xs));
  }

  &.gutter-sm {
    @include gutter.gutter(var(--spacing-sm));
  }

  &.gutter-md {
    @include gutter.gutter(var(--spacing-md));
  }

  &.gutter-lg {
    @include gutter.gutter(var(--spacing-lg));
  }
}
